import React from "react";
import { BookOpen, Check } from "lucide-react";
import { useBilling } from "@/contexts/BillingContext";
import { Trans, useTranslation } from "react-i18next";

export const BIG_BOOK_CHARS = 100000;
const CHARS_PER_PAGE = 3000;

// Shown under the text box when a very long text (book) is pasted / uploaded:
// tells the user exactly what to pick and how many credits it costs.
export function BigBookTip({ chars, mode, model, length, format, onApply }) {
  const { billing, freeAccess } = useBilling();
  const { t } = useTranslation();
  if (chars < BIG_BOOK_CHARS) return null;
  const pages = Math.round(chars / CHARS_PER_PAGE);
  const perCredit = billing?.chars_per_credit || 60000;
  const cost = Math.max(1, Math.ceil(chars / perCredit));
  const applied = mode === "chapters" && model === "gemini-3-flash" && length === "medium" && format === "both";

  return (
    <div className="mx-6 md:mx-8 my-3 border border-[#002FA7] bg-[#002FA7]/5 p-4 text-[13px]" data-testid="big-book-tip">
      <div className="flex items-center gap-2 font-mono uppercase tracking-[0.15em] text-[11px] font-bold text-[#002FA7]">
        <BookOpen className="w-4 h-4" /> {t("trial.bigbook_title", { pages })}
      </div>
      <p className="mt-2 leading-relaxed">
        <Trans i18nKey="trial.bigbook_body" components={{ b: <b /> }} />
      </p>
      <p className="mt-2 leading-relaxed" data-testid="big-book-tip-cost">
        <Trans i18nKey="trial.bigbook_cost" values={{ count: cost }} components={{ b: <b /> }} />
        {freeAccess ? t("trial.bigbook_free") : ""}
        {t("trial.bigbook_global")}
      </p>
      <button
        type="button"
        onClick={onApply}
        disabled={applied}
        data-testid="big-book-tip-apply-btn"
        data-tip={t("tips.bigbook_apply", "Applique en 1 clic les réglages conseillés pour un gros ouvrage.")}
        className="mt-3 inline-flex items-center gap-2 font-mono uppercase tracking-[0.14em] text-[11px] px-4 py-2 bg-[#002FA7] text-white hover:bg-[#001a66] transition-colors disabled:opacity-60"
      >
        <Check className="w-3.5 h-3.5" /> {applied ? t("trial.bigbook_applied") : t("trial.bigbook_apply")}
      </button>
    </div>
  );
}

export default BigBookTip;
